<template>
  <div :class="{ 'is-frontendLogin': isFrontendLogin }">
    <!-- header:start -->
    <header id="header" class="header">
      <div class="header-search-title">
        <div class="formparts select"
          :class="{'is-visible-list': state.isOpenCategory}"
          @mouseenter="state.isOpenCategory = true"
          @mouseleave="state.isOpenCategory = false">
          <div class="select-label" role="select">{{ bookName }}<FontawesomeIcon :icon="state.isOpenCategory ? 'angle-up' : 'angle-down'" class="icn" /></div>
          <div class="select-option">
            <ul class="select-option-list ta-left">
              <li v-for="book in booksArray" :key="'book_key_' + book.book_id" role="option">
                <label>
                  <input type="radio" :value="book.book_id" @click="changeBook.emitEvent(book.book_revision_id)" name="group_rd_02" >
                  {{ book.name }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="document-menu">
        <router-link
          class="document-menu-button"
          :class="{ 'is-current': (currentIndex === 1) }"
          to="/pc/document-search">
          <span class="document-menu-text">検索</span>
        </router-link>
        <router-link
          class="document-menu-button"
          :class="{ 'is-current': (currentIndex === 2) }"
          to="/pc/document-list">
          <span class="document-menu-text ga-precedent-detail-mokuji">目次</span>
        </router-link>
      </div>

      <div class="header-label ga-document-bookmark" v-if="showBookmark && !isFromAdminSystem()" role="button" @click="clickBookmark.emitEvent" :class="{'is-active': isBookmark}">
        <FontawesomeIcon v-if="isBookmark" :icon="['fa','bookmark']" size="lg" class="ga-document-bookmark" />
        <FontawesomeIcon v-else :icon="['far','bookmark']" size="lg" class="ga-document-bookmark" />
      </div>
    </header>
    <!-- header:end -->
    <div class="menu-bar is-open" role="button" onclick="window.close()">
      <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  name: 'PCDocumentMenu',
  props: {
    bookName: {
      type: String
    },
    booksArray: {
      type: Array,
      default: []
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    showBookmark: {
      type: Boolean,
      default: false
    },
    isFrontendLogin: {
      type: Boolean,
      default: false
    },
    isBookmark: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const state = reactive({
      isOpenCategory: false
    })

    const changeBook = reactive({
      emitEvent: (bookRevisionId) => {
        context.emit('changeBook', bookRevisionId)
      }
    })

    const clickBookmark = reactive({
      emitEvent: () => {
        context.emit('clickBookmark')
      }
    })

    return {
      props,
      state,
      changeBook,
      clickBookmark,
      isFromAdminSystem
    }
  }
})
</script>

<style lang="scss" scoped>
.header {
  &-search {
    &-title {
      padding-right: 10px;
      min-width: 230px;
      &.label {
        min-width: auto;
        text-align: center;
        padding: 0 20px;
        white-space: nowrap;
        font-size: 1.8rem;
      }
      .formparts.select {
        .select-label {
          color: #fff;
          font-size: bold;
          font-size: 1.8rem;
        }
        .select-option label {
          font-size: 1.6rem;
          color: $color-content;
        }
        .select-option-list{
          width: fit-content;
          min-width: 100%;
        }
      }
    }
  }
  .document-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 100%;
      font-size: 16px;
      border-bottom: 4px solid transparent;
      &.is-current {
        border-color: #E5E3A0;
        color: #E5E3A0;
      }
    }
  }
}
.menu-bar {
  .icn {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 24px;
  }
}

.is-frontendLogin {
  #header,
  .menu-bar {
    top: 50px;
  }
}
</style>
